import React from 'react';
import get from 'lodash/get';
import isNaN from 'lodash/isNaN';
import { classSet } from '@umu/umu-dom';
import { ROLE } from '@umu/umu-types';
import { If } from 'common/src/components';
import { Button, Iconfont } from '@umu/umu-design';
import { UserAvatar, UserName, UserNameRole } from '../../../user';
import { toFixed } from '@umu/umu-util/src/number';
interface IProps {
    info: Record<string, any>;
    config: Record<string, any>;
}

const UserLabel = (props: IProps) => {
    const { info, config } = props;
    const {
        userLevelInfoKey = 'user_level',
        userMedalInfoKey = 'user_medal',
        showUserLevelKey = 'show_user_level',
        rankIndexKey = 'rankIndex',
        roleKey = 'is_cooperator',
        pointsKey = 'point',
        avatarKey = 'avatar',
        className = '',
        iconType = '',
        iconClassName = '',
        userNameKey = 'user_name',
        isShowRankIndex = false,
        userAvatarProps = {},
        buttonInfo = null,
        isShowPoints = false,
        subLabelInfo = null,
        userNameProps = {},
        isShowRole = false,
    } = config;
    const pointValue = isShowPoints ? toFixed(get(info, pointsKey), 2) : '';
    return (
        <div className={`ele-render-type-user-label-info ${className || ''}-user-label-info`}>
            <If condition={isShowRankIndex}>
                <div className={`rank-info ${className || ''}-rank-info`}>{Number(get(info, rankIndexKey))}</div>
            </If>
            <UserAvatar
                src={get(info, avatarKey)}
                width={32}
                className="ele-render-type-user-label-info-user-avatar"
                showUserLevel={Number(get(info, showUserLevelKey))}
                userLevelInfo={Number(get(info, userLevelInfoKey))}
                {...userAvatarProps}
            />
            <div
                className={classSet({
                    'ele-render-type-user-label-info-user-name-text': true,
                    'ele-render-type-user-label-info-user-name-text-rank': isShowRankIndex,
                })}
            >
                <div className="ele-render-type-user-label-info-user-name-info">
                    <UserName
                        name={get(info, userNameKey)}
                        userMedalInfo={get(info, userMedalInfoKey)}
                        showUserLevel={get(info, showUserLevelKey)}
                        userMedalWidth={20}
                        transcate={true}
                        {...userNameProps}
                    />
                    <If condition={isShowRole}>
                        <UserNameRole role={Boolean(get(info, roleKey)) ? ROLE.TEACHER : ROLE.STUDENT} />
                    </If>
                </div>
                <If condition={isShowPoints && !isNaN(pointValue)}>
                    <div className={`ele-render-type-user-label-info-point ${className || ''}-point`}>
                        {iconClassName && <i className={`icon icon-split ${iconClassName}`} />}
                        {iconType && (
                            <Iconfont type={iconType} className="icon-split ele-render-type-user-label-info-icon" />
                        )}
                        <span>{pointValue}</span>
                    </div>
                </If>
                <If condition={!!subLabelInfo}>
                    <div className={`ele-render-type-user-label-info-sub ${className || ''}-sub`}>
                        {subLabelInfo?.iconClassName && (
                            <i className={`icon icon-split ${subLabelInfo?.iconClassName}`} />
                        )}
                        {subLabelInfo?.iconType && (
                            <Iconfont
                                type={subLabelInfo?.iconType}
                                className="icon-split ele-render-type-user-label-info-icon"
                            />
                        )}
                        <span>
                            {subLabelInfo?.getElementInfo
                                ? subLabelInfo?.getElementInfo(props)
                                : subLabelInfo?.label || ''}
                        </span>
                    </div>
                </If>
            </div>
            <If condition={!!buttonInfo}>
                <Button {...buttonInfo} onClick={() => buttonInfo.onClick(props)}>
                    {buttonInfo?.label}
                </Button>
            </If>
        </div>
    );
};

export { UserLabel };
